import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface DemoPanelProps {
  children: ReactNode;
  // Announce changes politely (the panel that shows a demo's result).
  isLive?: boolean;
  className?: string;
}

// The two-column layout every guide demo uses (the preview's `.tool`):
// controls on the left, the result on the right, stacked on phones.
export const demoGridClass =
  "grid items-start gap-[22px] lg:grid-cols-[minmax(0,1fr)_minmax(0,1.05fr)]";

// A demo's small step heading ("1. What kind of business do you run?").
export const demoHeadingClass = "text-base leading-snug font-bold text-ink";

// One white card of a guide demo (the preview's `.tool-l` / `.tool-r`).
const DemoPanel = ({ children, isLive = false, className }: DemoPanelProps) => (
  <div
    aria-live={isLive ? "polite" : undefined}
    className={cn(
      "grid min-w-0 content-start gap-3.5 rounded-[28px] bg-white p-5 text-ink shadow-card sm:p-[26px]",
      className,
    )}
  >
    {children}
  </div>
);

export default DemoPanel;
